import moment from "moment";
import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchReturnApprovalsList = createAsyncThunk("fetchReturnApprovalsList", async ({ filters, page, limit }, { rejectWithValue }) => {
	try {
		// Extract start and end dates from range array if available
		let startDate = filters?.range?.[0] || filters?.startDate || "";
		let endDate = filters?.range?.[1] || filters?.endDate || "";
		startDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
		endDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

		const params = new URLSearchParams({
			page: page,
			limit: limit,
			statusId: filters?.statusId ?? "",
			priorityId: filters?.priorityId ?? "",
			keyword: filters?.keyword?.trim() ?? "",
			returnType: filters?.returnType ?? "",
			startDate: startDate,
			endDate: endDate,
		});

		const response = await axiosHttp.get(`returns?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while fetching list");
	}
});

const ReturnApprovalsListSlice = createSlice({
	name: "ReturnApprovalsListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchReturnApprovalsList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchReturnApprovalsList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage || 1;
			state.total = action.payload.total || 0;
		});

		builder.addCase(fetchReturnApprovalsList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default ReturnApprovalsListSlice.reducer;
